import React from "react";
import "../styles/loader.scss";
import Lottie from "lottie-react";
import loaderAnimation from "../loader.json";

const Loader = () => {
  return (
    <>
      <section className="loader_img">
        <div id="particles-foreground"></div>
        <div id="particles-background"></div>

        <div className="vertical-centered-box">
          <div className="content">
            <Lottie
              animationData={loaderAnimation}
              loop={true}
              style={{ width: 220 }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Loader;
